import mapPeCompanyShortFromApi from 'rtkQuery/sharespro/mapper/modules/pe/peCompany/mapPeCompanyShortFromApi';
import mapPaginationListFromApi from 'rtkQuery/sharespro/mapper/shared/mapPaginationListFromApi';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';

export const mapPeCompanyOrderListItemFromApi = (
  apiItem: ApiPeCompanyOrderListItem
): PeCompanyOrderListItem => ({
  id: apiItem.id,
  company: mapPeCompanyShortFromApi(apiItem.company),
  createdAt: new Date(apiItem.create_timestamp * 1000),
  quantity: apiItem.quantity,
  price: apiItem.price,
  volume: apiItem.sum,
  subtitle1: apiItem.subtitle_1,
  subtitle2: apiItem.subtitle_2,
});

const mapPeCompanyOrderListFromApi = (
  resp: SharesproApiResponse<
    ApiPaginationListResponse<ApiPeCompanyOrderListItem>
  >
): PaginationList<PeCompanyOrderListItem> => {
  return mapPaginationListFromApi<
    PeCompanyOrderListItem,
    ApiPeCompanyOrderListItem
  >(resp.data, mapPeCompanyOrderListItemFromApi);
};

export default mapPeCompanyOrderListFromApi;
